import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './QuickLinks.module.sass';
import PinRed from './pin_red.png';
import PinGrey from './pin_grey.png';
import ChevronRed from './down_arrow_red.png';
import ChevronGrey from './up_arrow_grey.png';
import { Link } from 'react-router-dom';
import {
  createFavoriteJourney,
  deleteFavoriteBySubTitle,
  createHomework,
  deleteHomework,
} from '../../../api/api';
import { useVideoCategoriesByAction } from '../../../hooks/useVideoCategoriesByAction';
import {
  deleteFavorite,
  addFavorite,
  addHomework,
  removeHomework,
} from '../../../Redux/listViewReducer';
import { setCategory } from '../../../Redux/listViewCategoryReducer';
import { setSubcategory } from '../../../Redux/listViewSubcategoryReducer';
import useUserTeams from '../../../hooks/useUserTeam';
import { ModalAssignment } from '../../ProfilePage/ModalWindowPopap/ModalAssignment';

const QuickLinks = (props) => {
  const { accessAllVideos, setShowUpgradePopup } = props;
  const { data } = useSelector((state) => state.listViewReducer);
  const selectedCategory = useSelector((state) => state.listViewCategoryReducer);
  const selectedSubCategory = useSelector((state) => state.listViewSubcategoryReducer);

  const [selectedCategories, setSelectedCategories] = useState([]);

  const favoriteData = useVideoCategoriesByAction('SET_MY_FAVORITE_CATEGORY_DATA').find(
    (item) => item.actionType === 'SET_MY_FAVORITE_SUBCATEGORY_DATA',
  ).children;
  const dispatch = useDispatch();
  const activeStyle = { color: '#86adc5' };
  const hiddenStyle = { display: 'none' };
  const playerID = useSelector((state) => state.playerDataReducer.playerData.id);
  const fromListViewPage = true;
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedHomeworks, setSelectedHomeworks] = useState([]);
  const { manageTeams } = useUserTeams();
  const { data: list } = useSelector((state) => state.listViewReducer);

  const handleCategoryClick = (category) => {
    if (selectedCategories.includes(category?.actionType)) {
      setSelectedCategories(selectedCategories.filter((c) => c !== category?.actionType));
    } else {
      setSelectedCategories([...selectedCategories, category?.actionType]);
    }

    if (category?.actionType !== 'SET_MY_HOMEWORK_DATA') {
      dispatch(setCategory(category?.actionType));
      dispatch(setSubcategory(category?.children[0]?.actionType));
    }
  };
  const hiddenData = useVideoCategoriesByAction('SET_MY_HIDDEN_CATEGORY_DATA').find(
    (item) => item.actionType === 'SET_MY_HIDDEN_SUBCATEGORY_DATA',
  ).children;

  const homeworkData = useMemo(() => {
    const allHomework = list
      ?.find((item) => item.actionType === 'SET_MY_HOMEWORK_DATA')
      .children.map((item) => item.children[0].children)
      .flat();

    // Use reduce to filter out duplicate entries based on title and subTitle
    const uniqueHomework = allHomework.reduce((acc, current) => {
      const duplicate = acc.find(
        (item) => item?.title === current?.title && item?.subTitle === current?.subTitle,
      );
      if (!duplicate) {
        return [...acc, current];
      }
      return acc;
    }, []);

    return uniqueHomework;
  }, [list]);

  const checkFavorite = useCallback(
    (_item) => {
      return favoriteData.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle;
        } else {
          return item.title === _item.title;
        }
      });
    },
    [favoriteData],
  );

  const checkHiddenFolder = useCallback(
    (_item) => {
      if ('hiddenWeeklyPlan' in _item) {
        return _item.hiddenWeeklyPlan;
      } else if ('hiddenKeySkill' in _item) {
        return _item.hiddenKeySkill;
      } else if ('hiddenCustomTraining' in _item) {
        return _item.hiddenCustomTraining;
      }
      const hiddenCheck = hiddenData?.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle && !item.folderId;
        } else {
          return item.title === _item.title && !item.folderId;
        }
      });
      return hiddenCheck;
    },
    [hiddenData],
  );

  const checkHomeworkWithFavorite = useCallback(
    (_item) => {
      const homeworkCheck = homeworkData.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle;
        } else {
          return item.title === _item.title;
        }
      });

      const favoriteCheck = favoriteData.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle;
        } else {
          return item.title === _item.title;
        }
      });

      return manageTeams.length > 0 ? homeworkCheck || favoriteCheck : favoriteCheck;
    },
    [favoriteData, homeworkData, manageTeams],
  );

  const handleFavoriteClick = useCallback(
    async (item) => {
      if (manageTeams.length > 0) {
        setSelectedItem(item);
        return;
      }

      if (manageTeams.length === 0) {
        if (checkFavorite(item)) {
          await deleteFavoriteBySubTitle(item).then((res) => {
            console.log(res.msg);
            dispatch(deleteFavorite(item));
          });
        } else {
          await createFavoriteJourney(item).then((res) => {
            dispatch(addFavorite(res.favorite));
          });
        }
      }
    },
    [checkFavorite, manageTeams, dispatch],
  );

  const checkHomeworkWithTeam = useCallback(
    (team, _item) => {
      const teamData = list
        ?.find((item) => item.actionType === 'SET_MY_HOMEWORK_DATA')
        ?.children.find((item) => item.actionType === `cat-${team.id}`)?.children[0].children;

      const homeworkCheck = teamData?.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle;
        } else {
          return item.title === _item.title;
        }
      });

      return homeworkCheck;
    },
    [list],
  );

  const onSubmit = useCallback(
    async (teams, addToFavorite) => {
      // Remove homework from teams that have been unchecked
      const teamsToRemoveHomework = manageTeams.filter(
        (team) =>
          checkHomeworkWithTeam(team, selectedItem) &&
          !teams.some((selectedTeam) => selectedTeam.id === team.id),
      );

      for (const team of teamsToRemoveHomework) {
        await deleteHomework({ ...selectedItem, team }).then((res) => {
          console.info(res.msg);
          dispatch(removeHomework(selectedItem, team));
        });
      }

      // Add homework to newly selected teams
      for (const team of teams) {
        if (!checkHomeworkWithTeam(team, selectedItem)) {
          await createHomework({ ...selectedItem, teamId: team.id }).then((res) => {
            console.info(res.success);
            dispatch(addHomework(selectedItem, team));
          });
        }
      }

      // Handle favorites
      if (checkFavorite(selectedItem) === false && addToFavorite === true) {
        await createFavoriteJourney(selectedItem).then((res) => {
          dispatch(addFavorite(res.favorite));
        });
      }

      if (checkFavorite(selectedItem) === true && addToFavorite === false) {
        await deleteFavoriteBySubTitle(selectedItem).then((res) => {
          console.log(res.msg);
          dispatch(deleteFavorite(selectedItem));
        });
      }

      setSelectedItem(null);
    },
    [checkFavorite, checkHomeworkWithTeam, selectedItem, dispatch, manageTeams],
  );

  const handleHomeworkClick = (child) => {
    if (selectedHomeworks.includes(child?.actionType)) {
      setSelectedHomeworks(selectedHomeworks.filter((c) => c !== child?.actionType));
    } else {
      setSelectedHomeworks([...selectedHomeworks, child?.actionType]);
    }
  };

  return (
    <>
      <ul>
        {data
          .slice(0, 6)
          .toReversed()
          .map((category) => {
            let children = [];
            if (category?.actionType === 'SET_MY_HOMEWORK_DATA') {
              children = category?.children;
            } else {
              children = category?.children[0]?.children[0]?.children;
            }
            return (
              <div key={category.title} className={styles.menuRow}>
                <div onClick={() => handleCategoryClick(category)}>
                  <div className={styles.menuItem}>
                    <img
                      className={styles.icon}
                      src={selectedCategories.includes(category?.actionType) ? PinGrey : PinRed}
                    />
                    <span
                      style={selectedCategories.includes(category?.actionType) ? activeStyle : {}}
                    >
                      {category.title}
                    </span>
                  </div>
                  <div className={styles.chevronColumn}>
                    <img
                      className={styles.chevron}
                      src={
                        selectedCategories.includes(category?.actionType) ? ChevronGrey : ChevronRed
                      }
                    />
                  </div>
                </div>
                {selectedCategories.includes(category?.actionType) ? (
                  <ul className={styles.subCategory}>
                    {children
                      .filter(
                        (item) =>
                          !item.hiddenWeeklyPlan &&
                          !item.hiddenKeySkill &&
                          !item.hiddenCustomTraining,
                      )
                      .filter(
                        (item) =>
                          (item?.status !== 'draft' && !item.hidenForUsers?.includes(playerID)) ||
                          item.assignedUsers?.includes(playerID),
                      )
                      .map((child) => {
                        let link;
                        if (!child?.actionType || child.type === 'folder') {
                          link = `/my-training-sessions/${child?.folderId || child.id}`;
                        } else {
                          const basePath = child?.subFolder || child.actionType;
                          const title = child?.subFolder ? child.title : child.subTitle;
                          link = `${basePath}/${title}/${fromListViewPage}`;
                        }
                        const categoriesRegex = /^cat-\d+$/;
                        if (
                          category?.actionType !== 'SET_MY_HIDDEN_CATEGORY_DATA' &&
                          !categoriesRegex.test(category?.actionType) &&
                          checkHiddenFolder(child)
                        ) {
                          return null;
                        }
                        // workaround for key skills, custom training and weekly plans for unique keys
                        const key = child.folderId
                          ? `${child.title}-${child.hiddenWeeklyPlan}-${child.hiddenKeySkill}-${child.hiddenCustomTraining}`
                          : child.title;

                        return (
                          <li
                            key={key}
                            style={child?.actionType === selectedSubCategory ? activeStyle : {}}
                          >
                            {category?.actionType === 'SET_MY_HOMEWORK_DATA' ? (
                              <>
                                <div
                                  className={styles.menuItem}
                                  onClick={() => handleHomeworkClick(child)}
                                  style={
                                    selectedHomeworks.includes(child?.actionType) ? activeStyle : {}
                                  }
                                >
                                  <img
                                    className={styles.subIcon}
                                    src={
                                      selectedHomeworks.includes(child?.actionType)
                                        ? PinGrey
                                        : PinRed
                                    }
                                  />
                                  <span>{child.title}</span>
                                </div>
                                <div className={styles.chevronColumn}>
                                  <img
                                    className={styles.chevron}
                                    src={
                                      selectedHomeworks.includes(child?.actionType)
                                        ? ChevronGrey
                                        : ChevronRed
                                    }
                                  />
                                </div>
                                <ul
                                  style={
                                    selectedHomeworks.includes(child?.actionType) ? {} : hiddenStyle
                                  }
                                >
                                  {child?.children[0]?.children
                                    .filter(
                                      (item) =>
                                        (item?.status !== 'draft' &&
                                          !item.hidenForUsers?.includes(playerID)) ||
                                        item.assignedUsers?.includes(playerID),
                                    )
                                    ?.filter(
                                      (item) =>
                                        !(
                                          item.hidenForUsers?.includes(playerID) ||
                                          item.nextUpForUsers?.includes(playerID)
                                        ),
                                    )
                                    .map((item) => {
                                      let childLink;
                                      if (!item?.actionType || item.type === 'folder') {
                                        childLink = `/my-training-sessions/${
                                          item?.folderId || item.id
                                        }`;
                                      } else {
                                        const basePath = item?.subFolder || item.actionType;
                                        const title = item?.subFolder ? item.title : item.subTitle;
                                        childLink = `${basePath}/${title}/${fromListViewPage}`;
                                      }
                                      return (
                                        <li key={item.id} className={styles.homeworkItem}>
                                          <img className={styles.homeworkIcon} src={PinRed} />
                                          <Link
                                            to={childLink}
                                            onClick={(e) => {
                                              if (accessAllVideos !== true) {
                                                e.preventDefault();
                                                setShowUpgradePopup(true);
                                              }
                                            }}
                                          >
                                            {item.title}
                                          </Link>
                                        </li>
                                      );
                                    })}
                                </ul>
                              </>
                            ) : (
                              <>
                                <img
                                  className={styles.subIcon}
                                  src={PinRed}
                                  // src={
                                  //   checkHomeworkWithFavorite(child) || checkFavorite(child)
                                  //     ? PinRed
                                  //     : PinGrey
                                  // }
                                  // onClick={() => {
                                  // handleFavoriteClick(child);
                                  // }}
                                />
                                <Link
                                  to={link}
                                  onClick={(e) => {
                                    if (accessAllVideos !== true) {
                                      e.preventDefault();
                                      setShowUpgradePopup(true);
                                    }
                                  }}
                                >
                                  {child.title}
                                </Link>
                              </>
                            )}
                          </li>
                        );
                      })}
                  </ul>
                ) : (
                  ''
                )}
              </div>
            );
          })}
      </ul>
      {selectedItem && (
        <ModalAssignment
          manageTeams={manageTeams}
          onClose={() => setSelectedItem(null)}
          initFav={checkFavorite(selectedItem)}
          onSubmit={onSubmit}
          selectedItem={selectedItem}
        />
      )}
    </>
  );
};

export default QuickLinks;
